/**
 * Property Map Alpine Component
 * Renders an interactive Mapbox map for listing pages
 */

import Alpine from 'alpinejs';
import { createMap, addMarker } from '../utils/mapbox.js';

Alpine.data('propertyMap', (config = {}) => ({
    map: null,
    marker: null,
    loaded: false,

    // Config with defaults
    center: config.center || [0, 0],
    zoom: config.zoom || 14,
    interactive: config.interactive ?? true,

    init() {
        // Wait for the element to be in the DOM
        this.$nextTick(() => {
            this.initMap();
        });
    },

    initMap() {
        // Create map using shared utility
        this.map = createMap(this.$refs.map, {
            center: this.center,
            zoom: this.zoom,
            interactive: this.interactive,
        });

        if (!this.map) return;

        // Add marker at center using shared utility
        this.marker = addMarker(this.map, this.center);

        // Mark as loaded when map is ready
        this.map.on('load', () => {
            this.loaded = true;
        });
    },

    destroy() {
        if (this.marker) {
            this.marker.remove();
        }
        if (this.map) {
            this.map.remove();
        }
    },
}));
